/**
 * @module app.portal.loginCtrl
 *
 * The var names witch contain "loading" mean : is a request pending ?
 */
define(['angular'], function(angular) {


    function LoginCtrl($scope, $rootScope, $location, authService) {
        let self = {};

        self.login = function() {
            authService.login();
        };

        self.loginHelpline = function() {
            authService.loginHelpline();
        }

        return self;
    }

    LoginCtrl.$inject = ['$scope', '$rootScope', '$location', 'authService'];

    angular.module('app.portal.loginCtrl', ['ui-notification']).controller('LoginCtrl', LoginCtrl);
});
